import LegalPageLayout from './LegalPageLayout';
import {
  TERMS_DOCUMENT_TITLE,
  TERMS_EFFECTIVE_DATE,
  TERMS_LAST_UPDATED,
  TERMS_SUBTITLE,
  TermsOfServiceContent,
} from './content/termsOfServiceContent';

const TermsOfServicePage = () => (
  <LegalPageLayout
    title={TERMS_DOCUMENT_TITLE}
    subtitle={TERMS_SUBTITLE}
    effectiveDate={TERMS_EFFECTIVE_DATE}
    lastUpdated={TERMS_LAST_UPDATED}
  >
    <TermsOfServiceContent />
  </LegalPageLayout>
);

export default TermsOfServicePage;
